import React from 'react';
import { Activity, TrendingUp, TrendingDown, Minus } from 'lucide-react';

export function PortStatus({ stats = {} }) {
  const { total = 0, up = 0, down = 0, error = 0 } = stats;
  
  return (
    <div className="space-y-4" data-testid="port-status">
      <h3 className="font-display text-sm uppercase tracking-wider text-muted-foreground">
        Status de Portas
      </h3>
      
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center p-3 bg-secondary/50 rounded-sm border border-border">
          <Activity className="h-5 w-5 mx-auto text-success mb-1" />
          <div className="text-2xl font-mono font-bold text-success">{up}</div>
          <div className="text-xs text-muted-foreground uppercase tracking-wider">UP</div>
        </div>
        
        <div className="text-center p-3 bg-secondary/50 rounded-sm border border-border">
          <Minus className="h-5 w-5 mx-auto text-muted-foreground mb-1" />
          <div className="text-2xl font-mono font-bold text-muted-foreground">{down}</div>
          <div className="text-xs text-muted-foreground uppercase tracking-wider">DOWN</div>
        </div>
        
        <div className="text-center p-3 bg-secondary/50 rounded-sm border border-border">
          <TrendingDown className="h-5 w-5 mx-auto text-destructive mb-1" />
          <div className="text-2xl font-mono font-bold text-destructive">{error}</div>
          <div className="text-xs text-muted-foreground uppercase tracking-wider">ERROR</div>
        </div>
      </div>
      
      {/* Progress bar */}
      <div className="h-2 bg-secondary rounded-full overflow-hidden flex">
        <div 
          className="bg-success transition-all"
          style={{ width: `${(up / total) * 100}%` }}
        />
        <div 
          className="bg-muted-foreground transition-all"
          style={{ width: `${(down / total) * 100}%` }}
        />
        <div 
          className="bg-destructive transition-all"
          style={{ width: `${(error / total) * 100}%` }}
        />
      </div>
    </div>
  );
}

export default PortStatus;
